import { render, staticRenderFns } from "./PrazoItemBemPermanenteModal.vue?vue&type=template&id=63ed49f7&scoped=true"
import script from "./PrazoItemBemPermanenteModal.vue?vue&type=script&lang=js"
export * from "./PrazoItemBemPermanenteModal.vue?vue&type=script&lang=js"
import style0 from "./PrazoItemBemPermanenteModal.vue?vue&type=style&index=0&id=63ed49f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed49f7",
  null
  
)

export default component.exports